// extracted by mini-css-extract-plugin
export var childrenContainer = "_b7-0";
export var virtualScrollArea = "_b7-1";